import { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Play, Smartphone, Server, AudioLines, Router } from 'lucide-react';

const actorIcon = (name) => {
  const n = name.toLowerCase();
  if (n.includes('kamailio') || n.includes('registrar') || n.includes('proxy')) return Server;
  if (n.includes('rtpengine')) return AudioLines;
  if (n.includes('gateway') || n.includes('pbx')) return Router;
  return Smartphone;
};

// An animated SIP ladder (sequence) diagram.
export default function Ladder({ title, actors, msgs }) {
  const [run, setRun] = useState(0);
  const reduce = useReducedMotion();
  const pos = (name) => ((actors.indexOf(name) + 0.5) / actors.length) * 100;
  const step = reduce ? 0 : 0.28;

  return (
    <figure className="ladder">
      <figcaption className="ladder-head">
        <span>{title}</span>
        <button type="button" className="ladder-replay" onClick={() => setRun((r) => r + 1)}>
          <Play size={14} /> Replay
        </button>
      </figcaption>
      <div className="ladder-scroll">
        <div className="ladder-canvas" style={{ minWidth: Math.max(actors.length * 170, 340) }}>
          <div className="ladder-actors" style={{ gridTemplateColumns: `repeat(${actors.length}, 1fr)` }}>
            {actors.map((a) => {
              const I = actorIcon(a);
              return (
                <div className="ladder-actor" key={a}>
                  <span className="ladder-actor-icon"><I size={18} /></span>
                  <span>{a}</span>
                </div>
              );
            })}
          </div>
          <div className="ladder-body" key={run}>
            {actors.map((a) => (
              <span key={a} className="ladder-life" style={{ left: `${pos(a)}%` }} />
            ))}
            {msgs.map(([from, to, label, kind = 'req'], i) => {
              const x1 = pos(from);
              const x2 = pos(to);
              const left = Math.min(x1, x2);
              const width = Math.abs(x2 - x1);
              const rtl = x2 < x1;
              return (
                <div className="ladder-row" key={i}>
                  <motion.span
                    className="ladder-label"
                    style={{ left: `${left + width / 2}%` }}
                    initial={{ opacity: 0, y: 4 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * step + 0.15, duration: 0.25 }}
                  >
                    {label}
                  </motion.span>
                  <motion.span
                    className={`ladder-arrow ladder-${kind} ${rtl ? 'is-rtl' : ''}`}
                    style={{ left: `${left}%`, width: `${width}%`, transformOrigin: rtl ? 'right' : 'left' }}
                    initial={{ scaleX: reduce ? 1 : 0 }}
                    animate={{ scaleX: 1 }}
                    transition={{ delay: i * step, duration: reduce ? 0 : 0.35, ease: 'easeOut' }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="ladder-legend">
        <span><i className="lg lg-req" /> request</span>
        <span><i className="lg lg-resp" /> response</span>
        <span><i className="lg lg-media" /> media (RTP)</span>
      </div>
    </figure>
  );
}
